import { mapFlowToWorkflowDefinition } from "./workflowFlowMapper";

/** Stable JSON fingerprint for dirty-state detection (manual save only — no session backup). */
export function buildWorkflowCanvasFingerprint({
  nodes,
  edges,
  name,
  workflowStart,
  sessionTimeoutSeconds,
  globalTransitions,
  intentName = "",
  exampleUtterances = [""],
  formatIntentName,
}) {
  const definition = mapFlowToWorkflowDefinition(nodes, edges, {
    start: workflowStart,
    sessionTimeoutSeconds,
    globalTransitions,
  });

  const fingerprintDefinition = { ...definition };
  const cleanIntent = formatIntentName?.(intentName) ?? "";
  if (cleanIntent) {
    fingerprintDefinition.intent = cleanIntent;
    fingerprintDefinition.routing = {
      examples: (exampleUtterances ?? []).map((utterance) => utterance.trim()).filter(Boolean),
    };
  }

  return JSON.stringify({
    name: name?.trim() || "",
    definition: fingerprintDefinition,
  });
}
